<template>
<div id="ProfileRecommendations" class="row">
    <div class="chart-segment-options col-3">
        <modal-link modal-id="Profile Recommendations" :content-list="pageContent"></modal-link>
        <a href="#!" v-show="!displayProfileRecommendations" @click="handleToggle">Show Recommendations<i class="fa fa-chevron-down ml-1"></i></a>
        <a href="#!" v-show="displayProfileRecommendations" @click="handleToggle">Hide Recommendations<i class="fa fa-chevron-up ml-1"></i></a>
    </div>
    <div v-if="displayProfileRecommendations && !isVerbatimLocked" class="product-recommendations-section col-9">
        <div>
            <div class="product-recommendations-intro">
                Generating Growth Recommendations uses data from your current Profile and Sentiment Themes above. Select which parts below to include for generating recommendations.
            </div>
            <div class="chart-criteria-section-1-product-recommendations-section">
                <div class="chart-criteria-row">
                    <div class="form-group">
                        <input id="includeValueGaps" name="includeValueGaps" type="checkbox" true-value="Y" false-value="N" v-model="includeValueGaps" />
                        <span class="ml-1 mr-3 mb-0">Include Value Gaps</span>
                    </div>
                    <div class="form-group">
                        <input id="includeExpectations" name="includeExpectations" type="checkbox" true-value="Y" false-value="N" v-model="includeExpectations" />
                        <span class="ml-1 mr-3 mb-0">Include Expectations</span>
                    </div>
                    <div class="form-group">
                        <input id="includePerformance" name="includePerformance" type="checkbox" true-value="Y" false-value="N" v-model="includePerformance" />
                        <span class="ml-1 mr-3 mb-0">Include Performance</span>
                    </div>
                    <div class="form-group">
                        <input id="includeWillingnessToPay" name="includeWillingnessToPay" type="checkbox" true-value="Y" false-value="N" v-model="includeWillingnessToPay" />
                        <span class="ml-1 mb-0">Include Willingness %s</span>
                    </div>
                </div>
                <div class="chart-criteria-row">
                    <div class="form-group">
                        <input id="includeRelativeStrength" name="includeRelativeStrength" type="checkbox" true-value="Y" false-value="N" v-model="includeRelativeStrength" />
                        <span class="ml-1 mr-3 mb-0">Include Relative Strength</span>
                    </div>
                    <div class="form-group">
                        <input id="includeSentimentThemes" name="includeSentimentThemes" type="checkbox" true-value="Y" false-value="N" v-model="includeSentimentThemes" />
                        <span class="ml-1 mr-3 mb-0">Include Sentiment Themes</span>
                    </div>
                    <div class="form-group">
                        <input id="includeReport" name="includeReport" type="checkbox" true-value="Y" false-value="N" v-model="includeReport" />
                        <span class="ml-1 mb-0">Include "The W Report" as PPTX file</span>
                    </div>
                </div>
            </div>
            <button class="btn btn-primary generate-recommendations-btn" @click="generateProfileRecommendations" :disabled="!processingComplete">
                <span>Generate Recommendations</span>
                <span v-show="this.$root.getLoading()" class="spinner-border spinner-border-sm"></span>
            </button>
        </div>
    </div>
</div>
</template>

<script>
import ContentMixins from "../../mixins/ContentMixins.vue";
import ViewMixins from "../../mixins/ViewMixins.vue";
import SurveyService from "../../services/survey.service";
import UserService from "../../services/user.service";
import AdminService from "../../services/admin.service";
import AdminMixins from "../../mixins/AdminMixins.vue";
import DataTableMixins from "../../mixins/DataTableMixins.vue";
import ChartCriteriaMixins from "../../mixins/ChartCriteriaMixins.vue";
import GoogleService from "../../services/google.service";
import ChartDisplaySkeleton from "../../components/skeleton/ChartDisplaySkeleton.vue";
import ClientSettingsService from "../../services/client.settings.service";
import AIService from "../../services/ai.service";
export default {
    name: "ProfileRecommendations",
    mixins: [ContentMixins, ViewMixins, DataTableMixins, AdminMixins, ChartCriteriaMixins, GoogleService],
    components: {
        //ChartDisplaySkeleton
    },
    data() {
        return {
            displayProfileRecommendations: false,
            clientSettings: {}, 
            includeValueGaps: "Y",
            includeExpectations: "Y",
            includePerformance: "Y",
            includeWillingnessToPay: "Y",
            includeRelativeStrength: "Y",
            includeSentimentThemes: "Y",
            includeReport: "Y",
            processingComplete: true,
            processInitiated: false,
            showResults: false,
        };
    },
    props: {
        entrySurveyCode: {
            type: String,
            default: SurveyService.getSurveyCode()
        },
        autoGenerateRecommendations: {
            type: Boolean,
            default: false
        },
        clientChart: {
            type: Object,
            default: function() {
                return {};
            }
        },
        aiRecommendations: {
            type: Object,
            required: true
        }
    },
    computed: {
        isVerbatimLocked() {
            return this.clientSettings.aiTypeId == 0;
        }
    },
    mounted() {
        ClientSettingsService.getClientSettings(this.clientCode, this.setClientSettings, this);
    //    console.log('AI Recommendations chartData = ', this.aiRecommendations);
    },
    created() {},
    methods: {
        setClientSettings(response){
            this.clientSettings = ClientSettingsService.parseClientSettings(response.data.data);
            this.displayProfileRecommendations = (this.isVerbatimLocked) ? false : true;
        },
        handleToggle() {
            if (this.isVerbatimLocked) {
                AdminService.displayErrorMessage({
                    text: "Profile Recommendations is not active for your organization. Contact your W Ratings Advisor for more information."
                });
                return;
            }
            this.toggleProfileRecommendations();
        },
        getDownloadFilename() {
            return "Recommendations - " + SurveyService.getSurveyName();
        },

        toggleProfileRecommendations() {
            let label = this.displayProfileRecommendations ? "close" : "open";
            GoogleService.logClickEvent("Profile Recommendations Section Toggle", label, 0, this);

            this.displayProfileRecommendations = !this.displayProfileRecommendations;
        },
        generateProfileRecommendations: function(){
            this.processingComplete = false;
            this.processInitiated = true;
            this.$root.processServerRequest("Processing Recommendations");
            const orgChartData = this.$parent.$data.aiRecommendations;
            const filteredChartData = this.filterChartData(orgChartData);
           // console.log('filteredChartData chartData = ',filteredChartData);
            
            let params = new URLSearchParams();
            params.append("client_id", this.clientObject.clientId);
            params.append("survey_id", SurveyService.getSurveyId());
            params.append("user_id", UserService.getUserId());
            params.append("include_value_gaps", this.includeValueGaps);
            params.append("include_expectations", this.includeExpectations);
            params.append("include_performance", this.includePerformance);
            params.append("include_willingness_to_pay", this.includeWillingnessToPay);
            params.append("include_relative_strength", this.includeRelativeStrength);
            params.append("include_sentiment_themes", this.includeSentimentThemes);
            params.append("include_report", this.includeReport);
            
           // console.log('...passing sentiments chartData ====', this.$parent.$data.aiSentimentsData);
            AIService.processRecommendations(params, this.processRecommendationsCallbacks);
        },
        loadCriteriaData() {
            let params = new URLSearchParams(this.clientChart.criteria);
            let autoProcessRecommendationsByAI = params.get("auto_process_recommendations_by_ai") || false;
            if (autoProcessRecommendationsByAI == "true" || autoProcessRecommendationsByAI == true) {
                this.includeValueGaps = params.get("include_value_gaps") || "Y";
                this.includeExpectations = params.get("include_expectations") || "Y";
                this.includePerformance = params.get("include_performance") || "Y";
                this.includeWillingnessToPay = params.get("include_willingness_to_pay") || "Y";
                this.includeRelativeStrength = params.get("include_relative_strength") || "Y";
                this.includeSentimentThemes = params.get("include_sentiment_themes") || "Y";
                this.includeReport = params.get("include_report") || "Y";

                this.displayProfileRecommendations = true;
                this.generateProfileRecommendations();
            }
        },
        saveToCard: function() {
            let params = new URLSearchParams();
            params.append("include_value_gaps", this.includeValueGaps);
            params.append("include_expectations", this.includeExpectations);
            params.append("include_performance", this.includePerformance);
            params.append("include_willingness_to_pay", this.includeWillingnessToPay);
            params.append("include_relative_strength", this.includeRelativeStrength);
            params.append("include_sentiment_themes", this.includeSentimentThemes);
            params.append("include_report", this.includeReport);
            params.append("auto_process_recommendations_by_ai", true);

            this.$emit("save-profile-recommendations-criteria", params);
        },
        filterChartData(payload) {

            const columnFlags = {
                "Need": true,
                "Gap": this.includeValueGaps === 'Y',
                "Expectations": this.includeExpectations === 'Y',
                "Performance": this.includePerformance === 'Y',
                "Willingness To Pay": this.includeWillingnessToPay === 'Y',
                "Relative Strength": this.includeRelativeStrength === 'Y'
            };
            const columnsToKeep = payload.columns.filter(col => {
                const matchedKey = Object.keys(columnFlags).find(key =>
                    col.toLowerCase().includes(key.toLowerCase())
                );
                // If header matches a flag key, use that flag
                if (matchedKey) {
                    return columnFlags[matchedKey];
                }
                // Otherwise keep by default
                return true;
            });
            const indexesToKeep = columnsToKeep.map(col =>
                payload.columns.indexOf(col)
            );
            const filteredRows = payload.rows.map(row =>
                indexesToKeep.map(index => row[index])
            );
            return {
                columns: columnsToKeep,
                rows: filteredRows
            };
        },
        processRecommendationsCallbacks(response) {
            this.$root.processServerResponse();
            let statusCode = response.status;
            this.showResults = true;
            if (statusCode == 200) {
                this.saveToCard();
                
                const data = response.data || {};
                // this.vendor = data?.aiType?.vendor || this.defaultVendor;
                // const all = (data?.topResults) ? (data.topResults) : [];
                // this.instructions = (data?.instructions) ? (data.instructions) : "";
                // const finalData = this.includeValueGaps ? this.setValueGaps(all) : all
                // this.results = finalData;
                // this.createVerbatimData(finalData);
                // if (!this.isSavedComments || this.isExplorerPage){
                // this.$nextTick(() => {
                //     this.initResultTables(finalData);
                // });
                // }
            } else {
                AdminService.displayErrorMessage({ text: response.message });
                //this.initResultTables([]);
            }
            this.$root.setLoading(false);
            this.processingComplete = true;
            }, 
    },
    watch: {
        clientChart: function() {
            if (this.clientChart != null && this.clientChart.clientChartId > 0 && this.autoGenerateRecommendations) {
                this.loadCriteriaData();
            }
        }
    },
};
</script>
